// Collection page: the phone Category select opens that collection; Sort reloads with Shopify's sort_by.

// A picker choice applies at once. Arrow keys on a closed select (Windows) change its value with no picker: that
// change waits for Enter, so stepping through options never leaves the page (WCAG 3.2.2); blur puts back the option.
function applyOnChoice(select, apply) {
  if (!select) return;
  let keyChange = false;
  let pending = false;
  const inEffect = () => [...select.options].find(option => option.defaultSelected);
  select.addEventListener('keydown', event => {
    if (event.key === 'Enter') {
      if (pending && select.value !== inEffect()?.value) {
        event.preventDefault();
        apply();
      }
      return;
    }
    // a closed select changes its value inside this keydown's default action; the flag ends with the task
    keyChange = true;
    setTimeout(() => { keyChange = false; });
  });
  select.addEventListener('change', () => {
    // arrowing back to the option in effect leaves nothing to apply
    if (keyChange) pending = select.value !== inEffect()?.value;
    else apply();
  });
  select.addEventListener('blur', () => {
    if (!pending) return;
    pending = false;
    const current = inEffect();
    if (current) select.value = current.value;
  });
  // bfcache or restored form values can leave the select on the old choice; a fresh load keeps any keystroke
  addEventListener('pageshow', event => {
    const type = performance.getEntriesByType('navigation')[0]?.type;
    if (!event.persisted && type !== 'back_forward' && type !== 'reload') return;
    pending = false;
    const current = inEffect();
    if (current) select.value = current.value;
  });
}

// ?sub=KEY (the section's subcategory chips) shows only cards whose Liquid-matched data-sub has it; an unknown key
// shows all. The Filter drawer hides then: its option counts describe the whole collection.
// shortcut: it filters the page the server sent (48 products); a collection past 48 would need real collections.
function initSubcategory(root) {
  try {
    applySubcategory(root);
  } finally {
    // the section's inline guard hid the heading and grid until now
    delete document.documentElement.dataset.subPending;
  }
}

function applySubcategory(root) {
  const chips = root.querySelector('.co-subchips');
  const key = new URLSearchParams(location.search).get('sub');
  const chip = chips && key ? [...chips.querySelectorAll('[data-sub-key]')].find(link => link.dataset.subKey === key) : null;
  if (!chip) return;
  let shown = 0;
  root.querySelectorAll('#co-grid .pg-tile').forEach(card => {
    const match = (card.dataset.sub || '').split(' ').includes(key);
    card.hidden = !match;
    if (match) shown += 1;
  });
  chips.querySelector('[aria-current]')?.removeAttribute('aria-current');
  chip.setAttribute('aria-current', 'page');
  const title = chip.dataset.subTitle;
  const heading = root.querySelector('#co-title');
  const crumb = root.querySelector('#co-crumb');
  if (crumb && !crumb.dataset.subApplied) {
    // Home / Shop the hats / OG Stally: the collection becomes a link back to all of it
    const parent = document.createElement('a');
    parent.href = chips.querySelector('[data-sub-all]').getAttribute('href');
    parent.textContent = crumb.textContent;
    const slash = document.createElement('span');
    slash.setAttribute('aria-hidden', 'true');
    slash.textContent = '/';
    crumb.before(parent, slash);
    crumb.dataset.subApplied = 'true';
  }
  if (crumb) crumb.textContent = title;
  if (heading) heading.textContent = title;
  const count = root.querySelector('#co-count');
  if (count) count.textContent = `${shown} ${shown === 1 ? 'product' : 'products'}`;
  root.querySelector('#co-sub-empty')?.toggleAttribute('hidden', shown > 0);
  const filter = root.querySelector('.co-filter-open');
  if (filter) filter.hidden = true;
  root.querySelector('.co-pages')?.setAttribute('hidden', '');
  if (!document.documentElement.dataset.subTitle) {
    document.documentElement.dataset.subTitle = title;
    document.title = `${title} – ${document.title}`;
  }
}

function initCollection(root = document) {
  initSubcategory(root);
  const category = root.querySelector('#co-cat');
  const sort = root.querySelector('#co-sort');
  applyOnChoice(category, () => { location.href = category.value; });
  applyOnChoice(sort, () => {
    const url = new URL(location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    location.href = url;
  });
}

initCollection();
// the theme editor re-renders a section without re-running scripts
document.addEventListener('shopify:section:load', event => initCollection(event.target));
